module.exports = __webpack_public_path__ + "static/city_img@2x-d73b9fe1b47edca25227977ba28ff4bf.png";